import React, { useContext, useState } from 'react'
import { Card, CardContent, Typography, Box, Grid } from '@mui/material'
import { InputButton, SearchAlert } from '../../../Simple'
import { RegraCancelamento } from '../../../Modais'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { IoIosArrowForward } from 'react-icons/io'
import { getSportNames } from '../../../../utils/functions'
import { AuthContext } from '../../../../contexts/AuthContext'
import { LocalStorage } from '../../../../services'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

export default function ListQuadras() {
  const { sttAuthCtx } = useContext(AuthContext)
  const { sttPg, actionsCtxEmps } = useContext(EmpresasContext)

  const [mostrarRegraCancelamento, setMostrarRegraCancelamento] = useState(false)
  function switchRegraCancelamento() {
    setMostrarRegraCancelamento(!mostrarRegraCancelamento)
  }

  function handleQuadraSelection(quadra) {
    actionsCtxEmps.handleLoads('gradeHorarios', true)
    LocalStorage.set('selected-quadra', quadra)
    actionsCtxEmps.handleModeSttPg({ modePg: 'grade', selectedQuadra: quadra, selectedHorarios: [] })
  }
  //console.log('SttPg :: ', sttPg)
  return (
    <>
      {mostrarRegraCancelamento && (
        <RegraCancelamento
          emp={sttPg.empresa}
          actionsCtxEmps={actionsCtxEmps}
          open={mostrarRegraCancelamento}
          onClose={switchRegraCancelamento}
          width='80%'
        />
      )}
      <Card
        sx={{
          // remover border radius e box shadow do MuiCard-root
          borderRadius: 0,
          boxShadow: 'none',
          paddingBottom: !sttAuthCtx.isLogged ? '45px' : '0px',
        }}
      >
        <Grid container sx={{ p: 1.5 }}>
          <Grid item xs={7}>
            <Typography variant='p' sx={{ fontFamily: 'jost-mediun', fontSize: '18px', fontWeight: 'bold' }}>
              Espaços disponíveis
            </Typography>
          </Grid>
          <Grid item xs={5} sx={{ display: 'flex', alignItems: 'center' }}>
            <InputButton
              variant='text'
              sx={{ '&.MuiButton-endIcon': { margin: '0px' }, p: 0 }}
              endIcon={<IoIosArrowForward size='0.8em' />}
              onClick={switchRegraCancelamento}
            >
              <Typography variant='caption' sx={{ whiteSpace: 'nowrap' }}>
                Regra de Cancelamento
              </Typography>
            </InputButton>
          </Grid>
        </Grid>
        <CardContent sx={{ padding: '0px 10px', height: '100%', width: '100%' }}>
          {sttPg.empresa?.quadras?.length ? (
            sttPg.empresa.quadras.map((quadra, index) => (
              <button
                key={index}
                style={{ border: 'none', padding: 0, width: '100%' }}
                onClick={() => {
                  handleQuadraSelection(quadra)
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    borderRadius: 3,
                    backgroundImage: `url(${quadra.urlFoto + quadra.foto})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: 150,
                    overflow: 'hidden',
                    '&::before': {
                      zIndex: 0,
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      backgroundColor: 'rgba(50, 50, 50, 0.5)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      position: 'relative',
                      padding: '10px',
                      height: '100%',
                    }}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                      <Box sx={{ width: '100%', textAlign: 'start' }}>
                        <Typography variant='h6' color='white' fontWeight='bold' sx={{ textShadow: '1.5px 1.5px 1.5px #242424' }}>
                          {quadra.descricao}
                        </Typography>
                        <Typography variant='body2' color='primary' fontWeight='bold' sx={{ textShadow: '1.5px 1.5px 1.5px #242424' }}>
                          {getSportNames(quadra.categoriasEsporte)}
                        </Typography>
                        <Typography variant='body2' color='white' sx={{ textShadow: '1.5px 1.5px 1.5px #242424' }}>
                          {quadra.endereco}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          height: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <ArrowForwardIosIcon color='primary' sx={{ filter: 'drop-shadow(0px 0px 6px #000000)' }} />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </button>
            ))
          ) : (
            <SearchAlert text={'No momento esse centro esportivo não oferece espaços para agendamento.'} />
          )}
        </CardContent>
      </Card>
    </>
  )
}
